var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6665C15.2833 25.6665 16.3333 24.6165 16.3333 23.3332H11.6666C11.6666 24.6165 12.7166 25.6665 14 25.6665ZM21 18.6665V12.8332C21 9.2515 19.0983 6.25317 15.75 5.45984V4.6665C15.75 3.69817 14.9683 2.9165 14 2.9165C13.0316 2.9165 12.25 3.69817 12.25 4.6665V5.45984C8.91329 6.25317 6.99996 9.23984 6.99996 12.8332V18.6665L4.66663 20.9998V22.1665H23.3333V20.9998L21 18.6665ZM18.6666 19.8332H9.33329V12.8332C9.33329 9.93984 11.095 7.58317 14 7.58317C16.905 7.58317 18.6666 9.93984 18.6666 12.8332V19.8332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.30aad46302879dc93efed0276ddf2b0f.svg";
export { ForwardRef as ReactComponent };